import React, { useEffect, useState } from 'react';
import {
	DialogTitle,
	DialogContent,
	// DialogActions,
	Typography,
	Box,
	Divider,
	Grid,
	List,
	ListItem,
	ListItemText,
	// Chip,
	// Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Button,
} from '@mui/material';
import {
	People,
	Email,
	Phone,
	LocationOn,
	Restaurant,
	LocalOffer,
	Receipt,
	CalendarToday,
	// Visibility,
} from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import { GetSingleQuotation } from '../../../services/api/quotation';

interface MenuType {
	menuItems: {
		Items: string[];
	};
	menuType: string;
	numberOfPersons: number;
	perPerson: number;
	price: number;
	_id: string;
}

interface ExtraEvent {
	item: string;
	price: number;
	_id: string;
}

interface ComplementaryItem {
	item: string;
	quantity: number;
	_id: string;
}

interface EventType {
	_id: string;
	eventType: string;
	menuType: string[];
	status: number;
	createdBy: string;
	createdAt: string;
	updatedAt: string;
	__v: number;
}

interface Quotation {
	_id: string;
	name: string;
	email: string;
	mobile: string;
	functionDate: string;
	location: string;
	eventType: EventType;
	isDefaultMenu: boolean;
	menuTypes: MenuType[];
	notification: boolean;
	subTotalPrice: number;
	discount: number;
	totalPrice: number;
	advance: number;
	balance: number;
	status: string;
	advanceAmounts: any;
	complementary: ComplementaryItem[];
	extratEvents: ExtraEvent[];
	quotationId: string;
	createdAt: string;
	updatedAt: string;
	__v: number;
	quotationPdf: string;
	masterquotationPdf: string;
}

const QuotationViewDialog = () => {
	const { id } = useParams();
	const [quotation, setQuotation] = useState<Quotation | null>(null);
	const [defaultMenu, setDefaultmenu] = useState<any | null>(null);
	console.log(defaultMenu, 'defaultmenu');
	const fetchData = async () => {
		const response = await GetSingleQuotation(id);
		console.log(response);
		if (response.success) {
			setQuotation(response?.data?.quotation);
			setDefaultmenu(response?.data?.quotation?.defaultMenuId);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	if (!quotation) return null;

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		});
	};

	return (
		<Box mt={15}>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<Button
					variant="outlined"
					// startIcon={<ArrowBackIcon />}
					onClick={() => window.history.back()}
					sx={{ ml: 2 }}
				>
					Back
				</Button>
			</Box>
			<DialogTitle>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">
						Quotation Details - {quotation?.quotationId}
					</Typography>
				</Box>
			</DialogTitle>
			<DialogContent dividers>
				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Box mb={3}>
							<Typography variant="subtitle1" gutterBottom>
								<Box display="flex" alignItems="center" gap={1}>
									<People color="primary" />
									<span>Customer Information</span>
								</Box>
							</Typography>
							<Divider />
							<Box mt={2} ml={3}>
								<Typography variant="body1">
									<PersonIcon fontSize="small" /> <span>{quotation?.name}</span>
								</Typography>
								<Typography variant="body1">
									<Box display="flex" alignItems="center" gap={1}>
										<Email fontSize="small" />
										<span>{quotation?.email}</span>
									</Box>
								</Typography>
								<Typography variant="body1">
									<Box display="flex" alignItems="center" gap={1}>
										<Phone fontSize="small" />
										<span>{quotation?.mobile}</span>
									</Box>
								</Typography>
							</Box>
						</Box>

						<Box mb={3}>
							<Typography variant="subtitle1" gutterBottom>
								<Box display="flex" alignItems="center" gap={1}>
									<Restaurant color="primary" />
									<span>Event Details</span>
								</Box>
							</Typography>
							<Divider />
							<Box mt={2} ml={3}>
								<Typography variant="body1">
									<FormatAlignJustifyIcon fontSize="small" />{' '}
									<span>{quotation?.eventType?.eventType}</span>
								</Typography>
								<Typography variant="body1">
									<Box display="flex" alignItems="center" gap={1}>
										<CalendarToday fontSize="small" />
										<span>{formatDate(quotation?.functionDate)}</span>
									</Box>
								</Typography>
								<Typography variant="body1">
									<Box display="flex" alignItems="center" gap={1}>
										<LocationOn fontSize="small" />
										<span>{quotation?.location}</span>
									</Box>
								</Typography>
							</Box>
						</Box>
					</Grid>

					<Grid item xs={12} md={6}>
						<Box mb={3}>
							<Typography variant="subtitle1" gutterBottom>
								<Box display="flex" alignItems="center" gap={1}>
									<Receipt color="primary" />
									<span>Pricing Breakdown</span>
								</Box>
							</Typography>
							<Divider />
							<Box mt={2} ml={3}>
								<List dense>
									<ListItem>
										<ListItemText primary="Subtotal" />
										<Typography>
											₹
											{defaultMenu
												? defaultMenu?.price
												: quotation?.subTotalPrice?.toFixed(2)}
										</Typography>
									</ListItem>
									<ListItem>
										<ListItemText primary="Extra Events" />
										<Typography>
											₹
											{quotation?.extratEvents
												.reduce((acc, item) => acc + item.price, 0)
												.toFixed(2)}
										</Typography>
									</ListItem>
									<ListItem>
										<ListItemText primary="Discount" />
										<Typography>₹{quotation?.discount?.toFixed(2)}</Typography>
									</ListItem>
									<ListItem sx={{ paddingLeft: 0 }}>
										{/* <ListItem> */}
										{/* <Box> */}
										{/* <TableContainer
														component={Paper}
														style={{
															boxShadow: 'none',
														}}
													> */}
										<Table size="small">
											{/* <TableHead>
																<TableRow>
																	<TableCell
																		style={{
																			borderBottom: 'none',
																		}}
																	>
																		Date
																	</TableCell>
																	<TableCell
																		style={{
																			borderBottom: 'none',
																		}}
																	>
																		Payment Method
																	</TableCell>
																	<TableCell
																		style={{
																			borderBottom: 'none',
																		}}
																	>
																		Amount
																	</TableCell>
																</TableRow>
															</TableHead> */}
											{/* <TableBody> */}
											{quotation?.advanceAmounts?.map(
												(item?: any, index?: any) => (
													<TableRow
														key={index}
														sx={{ marginLeft: 'auto' }}
													>
														<TableCell
															style={{
																borderBottom: 'none',
																marginLeft: 'auto',
															}}
														>
															{`Advance Paid ${index + 1}`}
														</TableCell>
														<TableCell
															style={{
																borderBottom: 'none',
															}}
														>
															{formatDate(item?.date)}
														</TableCell>
														<TableCell
															style={{
																borderBottom: 'none',
															}}
														>
															{`${item?.paymentMethod}${item.paymentMethod == 'Others' ? ` (${item.otherMethod})` : ''}`}
														</TableCell>
														<TableCell
															style={{
																borderBottom: 'none',
																textAlign: 'end',
																marginRight: 'auto',
															}}
														>
															₹ {item?.amount?.toFixed(2)}
														</TableCell>
													</TableRow>
												)
											)}
											{/* </TableBody> */}
										</Table>
										{/* </TableContainer> */}
										{/* </Box> */}
										{/* </ListItem> */}
									</ListItem>
									<Divider component="li" />
									<ListItem>
										<ListItemText primary="Total Amount" />
										<Typography variant="h6">
											₹
											{defaultMenu
												? (
														defaultMenu.price -
														quotation?.advanceAmounts?.reduce(
															(
																total: number,
																item: { amount: number }
															) => total + item?.amount,
															0
														)
													)?.toFixed(2)
												: quotation?.totalPrice?.toFixed(2)}
										</Typography>
									</ListItem>
									<ListItem>
										<ListItemText primary="Balance Due" />
										<Typography variant="h6">
											₹
											{defaultMenu
												? (
														defaultMenu.price -
														quotation?.advanceAmounts?.reduce(
															(
																total: number,
																item: { amount: number }
															) => total + item?.amount,
															0
														)
													)?.toFixed(2)
												: (
														quotation?.totalPrice -
														quotation?.advanceAmounts?.reduce(
															(
																total: number,
																item: { amount: number }
															) => total + item?.amount,
															0
														)
													)?.toFixed(2)}
										</Typography>
									</ListItem>
									{/* <ListItem>
											<ListItemText primary="Advance Paid" />
											<Typography>
												₹{quotation?.advance?.toFixed(2)}
											</Typography>
										</ListItem> */}
									{/* <ListItem>
											<ListItemText primary="Balance" />
											<Typography>
												₹{quotation?.balance?.toFixed(2)}
											</Typography>
										</ListItem> */}
								</List>
							</Box>
						</Box>
					</Grid>

					<Grid item lg={10}>
						<Box mb={3}>
							<Typography variant="subtitle1" gutterBottom>
								<Box display="flex" alignItems="center" gap={1}>
									<Restaurant color="primary" />
									<span>Menu Details</span>
								</Box>
							</Typography>
							<Divider />
							{defaultMenu ? (
								<>
									<Box mt={2}>
										<TableContainer component={Paper}>
											<Table size="small">
												<TableHead>
													<TableRow>
														<TableCell>Type</TableCell>
														<TableCell>Items</TableCell>
														{/* <TableCell>Per Person</TableCell> */}
														{/* <TableCell>Persons</TableCell> */}
														{/* <TableCell>Total</TableCell> */}
													</TableRow>
												</TableHead>
												<TableBody>
													{defaultMenu?.menuTypes?.map(
														(menu: any, index: any) => (
															<TableRow key={index}>
																<TableCell>
																	{menu?.menuType}
																</TableCell>
																<TableCell>
																	{menu?.menuItems.Items?.map(
																		(item: any, i: any) => (
																			<Typography
																				key={i}
																				sx={{
																					margin: 1,
																				}}
																			>
																				({i + 1}) {item}
																			</Typography>
																		)
																	)}
																</TableCell>
																{/* <TableCell>
																	₹{menu?.perPerson}
																</TableCell> */}
																<TableCell>
																	{menu?.numberOfPersons}
																</TableCell>
																{/* <TableCell>
																	₹{menu?.price}
																</TableCell> */}
															</TableRow>
														)
													)}
												</TableBody>
											</Table>
										</TableContainer>
									</Box>
									{defaultMenu?.extratEvents?.length > 0 && (
										<Box mb={3}>
											<Typography variant="subtitle1" gutterBottom>
												<Box display="flex" alignItems="center" gap={1}>
													<LocalOffer color="primary" />
													<span>Extra Events</span>
												</Box>
											</Typography>
											<Divider />
											<Box mt={2}>
												<TableContainer component={Paper}>
													<Table size="small">
														<TableHead>
															<TableRow>
																<TableCell>Item</TableCell>
																<TableCell>Price</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{defaultMenu?.extratEvents?.map(
																(item: any, index: any) => (
																	<TableRow key={index}>
																		<TableCell>
																			{item?.item}
																		</TableCell>
																		<TableCell>
																			₹{item?.price}
																		</TableCell>
																	</TableRow>
																)
															)}
														</TableBody>
													</Table>
												</TableContainer>
											</Box>
										</Box>
									)}

									{defaultMenu?.complementary?.length > 0 && (
										<Box mb={3} mt={5}>
											<Typography variant="subtitle1" gutterBottom>
												<Box display="flex" alignItems="center" gap={1}>
													<LocalOffer color="primary" />
													<span>Complimentary Items</span>
												</Box>
											</Typography>
											<Divider />
											<Box mt={2}>
												<TableContainer component={Paper}>
													<Table size="small">
														<TableHead>
															<TableRow>
																<TableCell>Item</TableCell>
																<TableCell>Quantity</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{defaultMenu?.complementary?.map(
																(item: any, index: any) => (
																	<TableRow key={index}>
																		<TableCell>
																			{item?.item}
																		</TableCell>
																		<TableCell>
																			{item?.quantity}
																		</TableCell>
																	</TableRow>
																)
															)}
														</TableBody>
													</Table>
												</TableContainer>
											</Box>
										</Box>
									)}
								</>
							) : (
								<>
									<Box mt={2}>
										<TableContainer component={Paper}>
											<Table size="small">
												<TableHead>
													<TableRow>
														<TableCell>Type</TableCell>
														<TableCell>Items</TableCell>
														<TableCell>Per Person</TableCell>
														<TableCell>Persons</TableCell>
														<TableCell>Total</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{quotation?.menuTypes?.map((menu, index) => (
														<TableRow key={index}>
															<TableCell>{menu?.menuType}</TableCell>
															<TableCell>
																{menu?.menuItems?.Items?.map(
																	(item, i) => (
																		<Typography
																			key={i}
																			sx={{
																				margin: 1,
																			}}
																		>
																			({i + 1}) {item}
																		</Typography>
																	)
																)}
															</TableCell>
															<TableCell>
																₹{menu?.perPerson}
															</TableCell>
															<TableCell>
																{menu?.numberOfPersons}
															</TableCell>
															<TableCell>₹{menu?.price}</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</TableContainer>
									</Box>
									{defaultMenu?.extratEvents?.length > 0 && (
										<Box mb={3}>
											<Typography variant="subtitle1" gutterBottom>
												<Box display="flex" alignItems="center" gap={1}>
													<LocalOffer color="primary" />
													<span>Extra Events</span>
												</Box>
											</Typography>
											<Divider />
											<Box mt={2}>
												<TableContainer component={Paper}>
													<Table size="small">
														<TableHead>
															<TableRow>
																<TableCell>Item</TableCell>
																<TableCell>Price</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{quotation?.extratEvents?.map(
																(item, index) => (
																	<TableRow key={index}>
																		<TableCell>
																			{item?.item}
																		</TableCell>
																		<TableCell>
																			₹{item?.price}
																		</TableCell>
																	</TableRow>
																)
															)}
														</TableBody>
													</Table>
												</TableContainer>
											</Box>
										</Box>
									)}

									{quotation?.complementary?.length > 0 && (
										<Box mb={3}>
											<Typography variant="subtitle1" gutterBottom>
												<Box display="flex" alignItems="center" gap={1}>
													<LocalOffer color="primary" />
													<span>Complimentary Items</span>
												</Box>
											</Typography>
											<Divider />
											<Box mt={2}>
												<TableContainer component={Paper}>
													<Table size="small">
														<TableHead>
															<TableRow>
																<TableCell>Item</TableCell>
																<TableCell>Quantity</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{quotation?.complementary?.map(
																(item, index) => (
																	<TableRow key={index}>
																		<TableCell>
																			{item?.item}
																		</TableCell>
																		<TableCell>
																			{item?.quantity}
																		</TableCell>
																	</TableRow>
																)
															)}
														</TableBody>
													</Table>
												</TableContainer>
											</Box>
										</Box>
									)}
								</>
							)}
						</Box>
					</Grid>
				</Grid>
			</DialogContent>
		</Box>
	);
};

export default QuotationViewDialog;
